import { ActionButton, Buttons, CancelButton, ModalCard } from '~/components';
import { useApi, useToast, useWorkspace } from '~/contexts';
import { useForm } from '~/hooks';
import React from 'react';

export default function SavePaymentToXeroDialog({ payment, resolve }) {
  const { workspace } = useWorkspace();
  const [{ isSubmitting, saved }, form] = useForm();
  const toast = useToast();
  const api = useApi();

  const handleSubmit = async () => {
    form.submit();

    try {
      await api.www.workspaces(workspace.id).clientPayments(payment.id).saveToXero();
      await resolve();
      toast.success(`Payment has been saved to Xero.`);
    } catch (error) {
      toast.error(
        error.message ??
          'An error has occurred. The payment has not been saved to Xero. Please review the Xero integration settings and try again.',
      );
      form.done();
    }
  };

  return (
    <ModalCard title="Save to Xero" onClose={() => resolve(false)}>
      <ModalCard.Body>Are you sure you want to save this payment to Xero?</ModalCard.Body>

      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={() => resolve(false)}>Cancel</CancelButton>
          <ActionButton isLoading={isSubmitting} ok={saved} onClick={handleSubmit}>
            Save
          </ActionButton>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}
